import { toggleDebugStatus } from 'store/debugSlice';
import { MainMenuItemsList } from 'app/navbar/MenuConfig';
import { devAPI } from 'api/api';

export const developmentMenuItems: MainMenuItemsList = [
    {
        label: 'development.form_example',
        key: 'development_form_example',
        href: '/dev/form',
        icon: { type: 'mi', value: 'columns' },
    },
    {
        label: 'development.component',
        key: 'development_component',
        href: '/dev/component',
        icon: { type: 'mi', value: 'plugin' },
    },
    {
        label: 'development.grid_example',
        key: 'development_grid_example',
        href: '/dev/grid',
        icon: { type: 'mi', value: 'datasets' },
    },
    {
        label: 'development.ui_library',
        key: 'development_ui_library',
        href: '/dev/ui',
        icon: { type: 'mi', value: 'plugin' },
    },
    {
        label: 'development.icons_mi',
        key: 'development_icons_mi',
        href: '/dev/icons',
        icon: { type: 'mi', value: 'file-image-o' },
    },
    {
        label: 'development.css_classes',
        key: 'development_css_classes',
        href: '/dev/css',
        icon: { type: 'mi', value: 'file-css' },
    },
    {
        label: 'development.shared_components',
        key: 'development_shared_components',
        href: '/dev/shared',
        icon: { type: 'mi', value: 'columns' },
    },
    {
        divider: true,
    },
    {
        label: 'development.ex_new_tab',
        key: 'development_ex_new_tab',
        href: '/editor',
        icon: { type: 'mi', value: 'share' },
        newTab: true,
    },
    {
        label: 'development.ex_other_site',
        key: 'development_ex_other_site',
        href: 'https://google.com.ua',
        icon: { type: 'mi', value: 'globe' },
        isExternal: true,
        newTab: true,
    },
    {
        label: 'development.ex_custom_action',
        key: 'development_ex_custom_action',
        action: () => {
            alert('Custom function');
        },
        icon: { type: 'mi', value: 'target' },
    },
    {
        label: 'development.rebuild_translations',
        key: 'rebuild_translations',
        action: () => {
            devAPI.loadFromFiles().then(() => {
                devAPI.writeToFiles();
            });
        },
        icon: { type: 'mi', value: 'vocabulary' },
    },
    {
        label: 'development.debug_mode',
        key: 'development_debug_mode',
        action: ({ dispatch }) => {
            if (dispatch) {
                dispatch(toggleDebugStatus());
            }
        },
        icon: { type: 'mi', value: 'advanced-configuration' },
    },
];
